const EUR = (n) => "€ " + Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 0 });

const STYLES = {
  raggiunto: { cls: "mst-raggiunto", ico: "🏆", sta: "RAGGIUNTO! 🎉🥂" },
  garantito: { cls: "mst-garantito", ico: "🔒", sta: "GARANTITO dai ricorrenti ✅" },
  in_traiettoria: { cls: "mst-traiettoria", ico: "⚡", sta: "In traiettoria col ritmo attuale" },
  extra: { cls: "mst-extra", ico: "🎯", sta: null },
};

export const MilestoneTrack = ({ proj }) => {
  if (!proj?.milestones) return null;
  const actual = proj.actual_revenue_ytd || 0;
  const base = proj.baseline_revenue || 0;
  const pct = base > 0 ? Math.round(actual / base * 1000) / 10 : 0;
  return (
    <div data-testid="milestones-track" style={{ marginTop: 14 }}>
      <div className="mst-now" data-testid="milestone-now">
        📍 OGGI: <b>{EUR(actual)}</b> · {pct}% del fatturato {proj.prev_year}
      </div>
      <div className="mst-row">
        {proj.milestones.map((m) => {
          const s = STYLES[m.status] || STYLES.extra;
          return (
            <div key={m.pct} className={"mst-card " + s.cls} data-testid={`milestone-${m.pct}`}>
              <div className="mst-ico">{s.ico}</div>
              <div className="mst-lbl">{m.pct === 0 ? `${proj.prev_year} SUPERATO` : `+${m.pct}%`}</div>
              <div className="mst-thr">{EUR(m.threshold)}</div>
              <div className="mst-sta">{s.sta || <>Sforzo extra: {EUR(m.missing_extra)}</>}</div>
            </div>
          );
        })}
      </div>
      <p className="muted" style={{ fontSize: 11.5, margin: "8px 0 0" }} data-testid="milestone-legend">
        🏆 già raggiunto · 🔒 garantito dai contratti ricorrenti · ⚡ ci arrivi mantenendo il ritmo attuale · 🎯 serve uno sforzo extra (quanto manca oltre la proiezione). Si aggiorna a ogni caricamento di fatture.
      </p>
    </div>
  );
};
